export interface ServiceListing {
  id: string;
  slug: string;
  title: string;
  providerName: string;
  providerSlug: string;
  providerRole: string;
  providerTower: string;
  providerUnit: string;
  category: string;
  description: string;
  rate?: string;
  tags: string[];
  rating: number;
  reviewCount: number;
  isSponsor?: boolean;
  isVerified: boolean;
}

export interface ServiceReview {
  id: string;
  serviceSlug: string;
  reviewerName: string;
  reviewerRole: string;
  reviewerTower: string;
  rating: number;
  body: string;
  serviceProvided: string;
  date: string;
}

export const mockServices: ServiceListing[] = [
  {
    id: 's1',
    slug: 'derek-okafor-personal-training',
    title: 'Personal Training & Nutrition Coaching',
    providerName: 'Derek Okafor',
    providerSlug: 'derek-okafor',
    providerRole: 'Resident',
    providerTower: 'Tower 2',
    providerUnit: '2208',
    category: 'Fitness',
    description: 'Certified personal trainer offering one-on-one sessions in the building gym or your unit. Specializing in strength training, body recomposition, and sustainable nutrition. Flexible scheduling for shift workers and remote professionals.',
    rate: '$85/session · $300/month (4 sessions)',
    tags: ['Strength Training', 'Nutrition', 'Body Recomposition', 'Flexible Hours'],
    rating: 4.9,
    reviewCount: 23,
    isVerified: true,
  },
  {
    id: 's2',
    slug: 'claire-fontaine-interior-design',
    title: 'Interior Design & Space Planning',
    providerName: 'Claire Fontaine',
    providerSlug: 'claire-fontaine',
    providerRole: 'Owner',
    providerTower: 'Tower 2',
    providerUnit: '2901',
    category: 'Interior Design',
    description: 'Principal designer with 12 years of experience in luxury high-rise residential. Have completed three full unit redesigns at Panorama. Services include full design, space planning, furniture sourcing, and renovation oversight.',
    rate: 'From $2,500 · Consultation $150',
    tags: ['Luxury Residential', 'High-Rise', 'Furniture Sourcing', 'Renovation'],
    rating: 5.0,
    reviewCount: 8,
    isVerified: true,
  },
  {
    id: 's3',
    slug: 'maya-johnson-yoga',
    title: 'Private Yoga & Meditation Sessions',
    providerName: 'Maya Johnson',
    providerSlug: 'maya-johnson',
    providerRole: 'Resident',
    providerTower: 'Tower 1',
    providerUnit: '1601',
    category: 'Wellness',
    description: 'Certified yoga instructor offering private and small group sessions. Available in your unit, the amenity deck, or the fitness center. Specializing in Vinyasa, Yin, and guided meditation. Morning and evening slots available.',
    rate: '$70/session · $240/month (4 sessions)',
    tags: ['Vinyasa', 'Yin Yoga', 'Meditation', 'Morning Sessions'],
    rating: 4.8,
    reviewCount: 17,
    isVerified: true,
  },
  {
    id: 's4',
    slug: 'leo-santos-photography',
    title: 'Portrait & Real Estate Photography',
    providerName: 'Leo Santos',
    providerSlug: 'leo-santos',
    providerRole: 'Resident',
    providerTower: 'Tower 1',
    providerUnit: '908',
    category: 'Photography',
    description: 'Commercial photographer available for headshots, unit listing photography, and personal portraits. Familiar with Panorama\'s lighting and spaces. Quick turnaround on edited files.',
    rate: 'Headshots from $200 · Unit listings from $350',
    tags: ['Headshots', 'Real Estate', 'Portraits', 'Fast Turnaround'],
    rating: 4.7,
    reviewCount: 14,
    isVerified: true,
  },
  {
    id: 's5',
    slug: 'marcus-chen-renovation-consulting',
    title: 'Renovation & Design Consulting',
    providerName: 'Marcus Chen',
    providerSlug: 'marcus-chen',
    providerRole: 'Owner',
    providerTower: 'Tower 1',
    providerUnit: '2204',
    category: 'Interior Design',
    description: 'Licensed architect offering renovation consulting for Panorama units. Familiar with building rules, structural constraints, and approved contractors. Can review plans, advise on permits, and help you avoid costly mistakes.',
    rate: '$200/hour · Project quotes available',
    tags: ['Architecture', 'Renovation', 'Permits', 'Contractor Vetting'],
    rating: 4.9,
    reviewCount: 11,
    isVerified: true,
  },
  {
    id: 's6',
    slug: 'panorama-cleaning-co',
    title: 'Premium Unit Cleaning Service',
    providerName: 'Panorama Cleaning Co.',
    providerSlug: 'panorama-cleaning-co',
    providerRole: 'Sponsor',
    providerTower: 'Tower 1',
    providerUnit: '',
    category: 'Cleaning',
    description: 'Professional cleaning service specializing in high-rise residential units. Bonded and insured. Familiar with Panorama building access procedures. Regular and deep-clean packages available.',
    rate: 'From $120 · Deep clean from $220',
    tags: ['Bonded & Insured', 'High-Rise Specialist', 'Regular & Deep Clean'],
    rating: 4.6,
    reviewCount: 31,
    isSponsor: true,
    isVerified: true,
  },
  {
    id: 's7',
    slug: 'james-whitfield-real-estate',
    title: 'Real Estate Consulting & Investment Advice',
    providerName: 'James Whitfield',
    providerSlug: 'james-whitfield',
    providerRole: 'Multiple Unit Owner',
    providerTower: 'Tower 1',
    providerUnit: '3101',
    category: 'Real Estate',
    description: 'Experienced developer and multi-unit owner at Panorama. Available for informal consultations on buying, selling, or investing in Panorama units. Insight on market trends, unit values, and building-specific considerations.',
    rate: 'Informal consultation — contact to discuss',
    tags: ['Investment', 'Buying & Selling', 'Market Insight', 'Panorama Specialist'],
    rating: 4.8,
    reviewCount: 6,
    isVerified: true,
  },
  {
    id: 's8',
    slug: 'paws-pet-care',
    title: 'In-Building Pet Care & Dog Walking',
    providerName: 'Paws Pet Care',
    providerSlug: 'paws-pet-care',
    providerRole: 'Sponsor',
    providerTower: 'Tower 2',
    providerUnit: '',
    category: 'Pet Care',
    description: 'Pet care service operating inside Panorama Towers. Dog walking, drop-in visits, and overnight pet sitting. Familiar with building pet policies and elevator etiquette.',
    rate: 'Dog walk $25 · Drop-in $20 · Overnight $65',
    tags: ['Dog Walking', 'Pet Sitting', 'In-Building', 'Insured'],
    rating: 4.7,
    reviewCount: 19,
    isSponsor: true,
    isVerified: true,
  },
];

export const mockServiceReviews: ServiceReview[] = [
  {
    id: 'rev1',
    serviceSlug: 'derek-okafor-personal-training',
    reviewerName: 'Priya Nair',
    reviewerRole: 'Owner',
    reviewerTower: 'Tower 1',
    rating: 5,
    body: 'Derek is exceptional. I\'ve been training with him for 8 months and the results have been remarkable. He\'s incredibly knowledgeable about nutrition and adapts sessions to my schedule as a physician. Having him in the building makes it so easy to stay consistent.',
    serviceProvided: 'Personal Training',
    date: 'February 2026',
  },
  {
    id: 'rev2',
    serviceSlug: 'derek-okafor-personal-training',
    reviewerName: 'Ryan Kowalski',
    reviewerRole: 'Renter',
    reviewerTower: 'Tower 1',
    rating: 5,
    body: 'Best investment I\'ve made since moving here. Derek tailored a program around my remote work schedule and I\'ve lost 18 lbs in 4 months. He\'s professional, punctual, and genuinely cares about your progress.',
    serviceProvided: 'Personal Training & Nutrition Coaching',
    date: 'January 2026',
  },
  {
    id: 'rev3',
    serviceSlug: 'derek-okafor-personal-training',
    reviewerName: 'Amanda Park',
    reviewerRole: 'Renter',
    reviewerTower: 'Tower 2',
    rating: 5,
    body: 'As a night shift nurse, my schedule is all over the place. Derek works around it without complaint. The sessions are challenging but never overwhelming. Highly recommend.',
    serviceProvided: 'Personal Training',
    date: 'December 2025',
  },
  {
    id: 'rev4',
    serviceSlug: 'claire-fontaine-interior-design',
    reviewerName: 'Marcus Chen',
    reviewerRole: 'Owner',
    reviewerTower: 'Tower 1',
    rating: 5,
    body: 'Claire redesigned my unit and the result is stunning. As an architect myself I had high expectations — she exceeded them. Her understanding of the building\'s proportions and light is exceptional.',
    serviceProvided: 'Full Interior Design',
    date: 'November 2025',
  },
  {
    id: 'rev5',
    serviceSlug: 'claire-fontaine-interior-design',
    reviewerName: 'Natasha Volkov',
    reviewerRole: 'Owner',
    reviewerTower: 'Tower 2',
    rating: 5,
    body: 'Hired Claire for a full redesign of my 33rd floor unit. The process was smooth, her vendor relationships saved me money, and the final result is magazine-worthy. Worth every dollar.',
    serviceProvided: 'Interior Design & Furniture Sourcing',
    date: 'October 2025',
  },
  {
    id: 'rev6',
    serviceSlug: 'maya-johnson-yoga',
    reviewerName: 'Sofia Reyes',
    reviewerRole: 'Renter',
    reviewerTower: 'Tower 2',
    rating: 5,
    body: 'Maya is a wonderful teacher. I do private sessions with her twice a week and it\'s completely transformed my mornings. She\'s patient, encouraging, and very attuned to what your body needs.',
    serviceProvided: 'Private Yoga Sessions',
    date: 'February 2026',
  },
  {
    id: 'rev7',
    serviceSlug: 'maya-johnson-yoga',
    reviewerName: 'Priya Nair',
    reviewerRole: 'Owner',
    reviewerTower: 'Tower 1',
    rating: 5,
    body: 'I\'ve tried many yoga instructors over the years. Maya is among the best. Her guided meditation sessions are particularly effective — I use them before long shifts.',
    serviceProvided: 'Meditation Coaching',
    date: 'January 2026',
  },
  {
    id: 'rev8',
    serviceSlug: 'leo-santos-photography',
    reviewerName: 'James Whitfield',
    reviewerRole: 'Multiple Unit Owner',
    reviewerTower: 'Tower 1',
    rating: 5,
    body: 'Leo shot two of my units for listing purposes. The photos were exceptional — he knows exactly how to capture the Strip views and the natural light in these units. Listings moved fast.',
    serviceProvided: 'Real Estate Photography',
    date: 'January 2026',
  },
  {
    id: 'rev9',
    serviceSlug: 'leo-santos-photography',
    reviewerName: 'Claire Fontaine',
    reviewerRole: 'Owner',
    reviewerTower: 'Tower 2',
    rating: 4,
    body: 'Great photographer with a good eye for interiors. Used him for portfolio shots of a unit I designed. Turnaround was fast and the edits were clean. Would use again.',
    serviceProvided: 'Interior Photography',
    date: 'December 2025',
  },
];
